import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@ameelio/ui";
import { useQuery } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { ContentSkeleton } from "../lib/closet";
import Link from "../lib/Link";
import Screen from "../lib/Screen";
import { GetOrganizationsDocument } from "./GetOrganizations.generated";

export default function OrganizationsScreen() {
  const { t } = useTranslation();
  const { data, error } = useQuery(GetOrganizationsDocument, {
    fetchPolicy: "cache-and-network",
  });

  if (error) throw error;
  if (!data) return <ContentSkeleton />;

  const organizations = data.organizations.edges.map((e) => e.node);

  return (
    <Screen title={t("Organizations")}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {organizations.map((o) => (
              <TableRow key={o.id}>
                <TableCell>{o.name}</TableCell>
                <TableCell>{o.type}</TableCell>
                <TableCell>
                  <Link to={`/toolbox/organizations/${o.id}`}>{t("View")}</Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Screen>
  );
}
